module.exports = __webpack_public_path__ + "static/media/hp-home-banner-@1x.9b89fee4.jpg";